/* Reika: default cart quantity from product "cfg-qty:N" tag (e.g. cfg-qty:5 for super-single tyre sets). Trekano configurator parity. */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
  if (!handle) return;
  fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.tags) return;
      var tag = (p.tags || []).filter(function (t) { return /^cfg-qty:\d+$/.test(t); })[0];
      if (!tag) return;
      var qty = parseInt(tag.split(':')[1], 10);
      if (!qty || qty < 1) return;
      function apply() {
        var inputs = document.querySelectorAll('input[name="quantity"]');
        for (var i = 0; i < inputs.length; i++) {
          var inp = inputs[i];
          if (inp.getAttribute('data-cfg-qty-set')) continue;
          // only default when still at 1 (don't override a user change)
          if (inp.value && parseInt(inp.value, 10) > 1) continue;
          inp.value = qty;
          inp.setAttribute('value', qty);
          inp.setAttribute('data-cfg-qty-set', '1');
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (document.readyState !== 'loading') apply();
      else document.addEventListener('DOMContentLoaded', apply);
      setTimeout(apply, 400);
      setTimeout(apply, 1200);
    })
    .catch(function () {});
})();